// extracted by mini-css-extract-plugin
export default {"menuBlock":"IF-z","title":"JF-z","nav":"KF-z","flexCell":"LF-z","facetLink":"MF-z"};